import React from 'react';
import IconLock from '../Icons/Lock/Lock';

type ComponentProps = {
  title: string
  subTitle: string;
  children?: React.ReactNode
}

const DeniedAccess: React.FC<ComponentProps> = ({ title, subTitle, children }) => {
  return (
    <div className='c-denied-access w-full h-full flex justify-center items-center'>
      <div className="max-md:w-full max-md:h-full max-md:flex max-md:flex-col max-md:justify-center max-md:items-center md:rounded-lg md:border md:border-stroke bg-white px-5 py-10 md:shadow-default sm:py-20">
        <IconLock iconClassName='pb-2' width='120px' height='120px' fill='#fb5454' />
        <div className="mt-7.5 text-center">
          <h2 className="mb-3 text-2xl font-bold text-black">
            {title}
          </h2>
          <p className="font-medium">
            {subTitle}
          </p>
          {children}
        </div>
      </div>
    </div>
  )
};

export default DeniedAccess;
